module.exports = __webpack_public_path__ + "img/mortgages.ab2a779.png";